export function isElementInView(element) {
  var rectangle = element.getBoundingClientRect();
  return (
    rectangle.top >= 0 &&
    rectangle.left >= 0 &&
    rectangle.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
export function createScroll (component) {
  window.addEventListener('scroll', component.handleScroll);
}
export function destroyScroll (component) {
  window.removeEventListener('scroll', component.handleScroll);
}
